import { useState, useEffect } from "react";
import { Reveal } from "./Reveal";
import { api, API } from "@/lib/api";

const TAG_STYLE = {
  V: "text-[#5fd08a] border-[#5fd08a]",
  VO: "text-[#5fd08a] border-[#5fd08a]/60",
  GFO: "text-[#ff8f6b] border-[#ff8f6b]",
};
const Tag = ({ t }) => (
  <span className={`font-mono-plex text-[9px] font-medium border rounded px-1.5 py-0.5 leading-none ${TAG_STYLE[t] || "text-background/60 border-background/40"}`}>{t}</span>
);

export const photoUrl = (path) => (path ? `${API}/files/${path}` : null);

export default function Menus() {
  const [menu, setMenu] = useState({ categories: [], items: {} });
  const [cat, setCat] = useState(null);

  useEffect(() => {
    api.get("/menu").then(({ data }) => {
      setMenu(data);
      setCat(data.categories[0] || null);
    }).catch(() => {});
  }, []);

  const items = (cat && menu.items[cat]) || [];

  return (
    <section id="menu" className="bg-foreground text-background py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div>
              <p className="overline text-primary">Eat &amp; drink</p>
              <h2 className="mt-3 font-head font-black tracking-tight leading-[0.95] text-4xl md:text-6xl">The Menu</h2>
            </div>
            <p className="font-mono-plex text-xs md:text-sm text-background/60 max-w-xs">
              Please let our bar staff know about any intolerances or allergies.
            </p>
          </div>
        </Reveal>

        <div className="mt-10 flex flex-wrap gap-2">
          {menu.categories.map((c) => (
            <button
              key={c}
              data-testid={`menu-tab-${c.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => setCat(c)}
              className={`font-head font-bold text-sm px-5 py-2.5 rounded-full border-2 transition-colors ${
                cat === c ? "bg-primary text-foreground border-primary" : "border-background/40 text-background hover:border-background"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-x-12 gap-y-2">
          {items.map((item, i) => {
            const url = photoUrl(item.photo_path);
            return (
              <Reveal key={item.id || i} delay={(i % 6) * 0.04}>
                <div className="flex items-center gap-4 py-4 border-b border-background/20" data-testid={`menu-item-${cat.toLowerCase().replace(/\s/g, "-")}-${i}`}>
                  {url && (
                    <img src={url} alt={item.name} className="w-16 h-16 rounded-lg object-cover border-2 border-background/30 shrink-0" />
                  )}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="font-head font-bold text-lg md:text-xl tracking-tight">{item.name}</h3>
                      {item.tags?.map((t) => <Tag key={t} t={t} />)}
                    </div>
                    {item.desc && <p className="text-background/60 text-sm mt-0.5">{item.desc}</p>}
                  </div>
                  {item.price && <span className="font-mono-plex text-lg text-primary shrink-0">${item.price}</span>}
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal>
          <div className="mt-14 flex flex-wrap items-center gap-4">
            <div className="flex items-center gap-3 font-mono-plex text-xs text-background/60">
              <span className="text-[#5fd08a]">V</span> Vegan
              <span className="text-[#5fd08a]">VO</span> Vegan option
              <span className="text-[#ff8f6b]">GFO</span> Gluten free option
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
